import createModule from "../createModule"
import view from "./view"
import { getRole } from "helpers/permissions/roles"
import { Creators } from "./model"
import withOutletContext from "hocs/withOutletContext"
import { Creators as UpdaterCreators } from "model/hookUpdater"
import { Creators as ModelCreators } from "model/data"
import { Creators as notificationCreators } from "modules/notifications/model"
import { getTabs, getTokens, getRestrictedFeatures, getTokenFeatures, getTokenFeaturesLoading, getAccountFeatures } from "./selectors"

import "./style.scss"

export default withOutletContext(createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
    accountId: state.global.selected.accountId,
    isSuperuser: state.user.isSuperuser,
  }),
  required: ["account"],
  data: [{
    resource: "tokens",
    passthrough: true,
    as: null,
    url: ({ account }) => ({
      id: `tokens-${account}`,
      query: `query {
        tokens {
          id
          name
          prefix
          createdBy {
            id
            name
          },
          createdAt
          lastUsedAt
          expiresOn
        }
      }`,
    }),
  }, {
    resource: "features",
    url: ({ account, isSuperuser }) => !isSuperuser ? null : ({
      id: `features-${account}`,
      url: "/api/admin/features",
    }),
  }, {
    resource: "accountFeatures",
    url: ({ account, accountId, isSuperuser }) => !isSuperuser ? null : ({
      id: `account-features-${account}`,
      url: `/api/admin/accounts/${accountId}/features`,
    }),
  }],
  mapStateToProps: (state, props) => ({
    tokens: getTokens(state),
    user: state.user,
    role: getRole(state),
    tabs: getTabs(state, props),
    features: getRestrictedFeatures(state, props),
    tokenFeatures: getTokenFeatures(state, props),
    isTokenFeaturesLoading: getTokenFeaturesLoading(state, props),
    accountFeatures: getAccountFeatures(state, props),
  }),
  actions: {
    ...UpdaterCreators,
    ...Creators,
    resetCollections: ModelCreators.resetCollections,
    addNotification: notificationCreators.add,
  },
}))
